export const FEE_LINK_TTL_DAYS = 7;

export const isFeeLinkExpiredUnpaid = (req) => {
  if (!req || req.type !== "bollettino" || req.payment_status === "paid" || !req.uploaded_at) return false;
  return Date.now() - new Date(req.uploaded_at).getTime() > FEE_LINK_TTL_DAYS * 86400000;
};

export const hasExpiredUnpaidFee = (practice) =>
  (practice?.entity_fee_requests || []).some(isFeeLinkExpiredUnpaid);
